import { BundleResourcesPackage } from "resource-system";
export class LocalizationResourcesPackage extends BundleResourcesPackage {
    public constructor() {
        super("LocalizationResourcesPackage");
    }
    public get assets_localization_cs_json(): Object {
        return this.resource<Object>("assets/localization/cs.json");
    }
    public get assets_localization_de_json(): Object {
        return this.resource<Object>("assets/localization/de.json");
    }
    public get assets_localization_en_json(): Object {
        return this.resource<Object>("assets/localization/en.json");
    }
    public get assets_localization_es_json(): Object {
        return this.resource<Object>("assets/localization/es.json");
    }
    public get assets_localization_fr_json(): Object {
        return this.resource<Object>("assets/localization/fr.json");
    }
    public get assets_localization_it_json(): Object {
        return this.resource<Object>("assets/localization/it.json");
    }
    public get assets_localization_ja_json(): Object {
        return this.resource<Object>("assets/localization/ja.json");
    }
    public get assets_localization_pl_json(): Object {
        return this.resource<Object>("assets/localization/pl.json");
    }
    public get assets_localization_ru_json(): Object {
        return this.resource<Object>("assets/localization/ru.json");
    }
}

